import PropTypes from "prop-types";
import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../axios/API";
import { DataContext } from '../DataProviders/DataProvider';
import { useSnackbar } from "../GlobalSnackbarProvider/GlobalSnackbarProvider";

// Create the context
const DomainContext = createContext();

// Create the provider component
const DomainProvider = ({ children }) => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar()
  const { userId, loginCustomerId } = useContext(DataContext);


  const [isOrgNameSubmitted, setIsOrgNameSubmitted] = useState(false);

  const [disableInput, setDisableInput] = useState(false);

  const [orgName, setOrgName] = useState('');

  const [emails, setEmails] = useState([]); // State for emails

  const [domainNumber, setDomainNumber] = useState(localStorage.getItem("dId") || 0);

  const [currentStep, setCurrentStep] = useState(localStorage.getItem("automationStep") ? parseInt(localStorage.getItem("automationStep")) : 0); // Manage the stepper state

  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedDomains, setSelectedDomains] = useState([]);
  const [cart, setCart] = useState([]);

  const [orderNumber, setOrderNumber] = useState(localStorage.getItem("automationOrderNo") || "");
  const [orderId, setOrderId] = useState(localStorage.getItem("automationOrderId") || "");

  const [isloading, setIsLoading] = useState(false);

  //Email Account useState
  const [hasClickedCheckout, setHasClickedCheckout] = useState(false);
  const [emailAccountData, setEmailAccountData] = useState([]);

  const [domainsState, setDomainsState] = useState([]);

  //Temp useStates
  const [domainList, setDomainList] = useState([]);
  const [isPrevious, setIsPrevious] = useState(false);

  const [emailFormData, setEmailFormData] = useState({})

  const [isCheckoutDisable, setIsCheckoutDisable] = useState(false);

  const [thisMonthTotalAmount, setThisMonthTotalAmount] = useState(0);
  const [thisYearDomainTotal, setThisYearDomainTotal] = useState(0);

  const [invoiceNumber, setInvoiceNumber] = useState(0);

  // New checkout-related states
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [invoiceId, setInvoiceId] = useState(0);
  const [promoCode, setPromoCode] = useState("");
  const [nextMonthTotalAmount, setNextMonthTotalAmount] = useState(0);
  const [discountPrice, setDiscountPrice] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const [applyPromoCodeLoader, setApplyPromoCodeLoader] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  //Domain Profile useState
  const [domainEmailAccountData, setDomainEmailAccount] = useState(() => {
    const storedData = sessionStorage.getItem("domainEmailAccountData");
    return storedData
      ? JSON.parse(storedData) // Parse if data exists
      : {
        forwardDomain: '',
        recoveryEmail: '',
        accessMethod: '',
        loginUrl: '',
        userName: '',
        password: '',
        domainCount: '',
        confirmAccess: ""
      };
  })

  // Domain Price List useState (persisted in localStorage)
  const [domainPriceList, setDomainPriceList] = useState(() => {
    try {
      const stored = localStorage.getItem("domain-price-list");
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      return [];
    }
  });
  const [order, setOrder] = useState(null);
  // Fetch billing data function
  const fetchData = async (code) => {
    try {
      // Retrieve promo code from localStorage
      const storedPromoCode = localStorage.getItem("promoCode") || "";

      // Determine the promo code to use
      const finalPromoCode = code || storedPromoCode;

      // Store promo code in localStorage if not already stored
      if (!storedPromoCode && code) {
        localStorage.setItem("promoCode", code);
      }

      // If a new promo code is being applied, validate it first
      if (code && code.trim()) {
        setApplyPromoCodeLoader(true);

        // First validate the promo code
        try {
          const validationResponse = await API.get(
            `${import.meta.env.VITE_BACKEND_API}/validate/promo-code`,
            {
              params: {
                promoCode: code.trim(),
                customerId: loginCustomerId
              }
            }
          );

          // Check if validation was successful (200 status means valid)
          if (validationResponse.status !== 200) {
            setDisableInput(false);
            showSnackbar("Invalid or already used promo code", "error");
            return;
          }
        } catch (error) {
          // Handle 400 status code or any other error
          if (error.response && error.response.status === 400) {
            setDisableInput(false);
            showSnackbar("Invalid or already used promo code", "error");
            return;
          }
          // Handle other errors
          setDisableInput(false);
          showSnackbar("Error validating promo code", "error");
          return;
        }

        // If validation passed, proceed with storing the promo code
        setDisableInput(true);
        localStorage.setItem("promoCode", code);
      }

      if (code && code.length === 0) {
        setLoading(true);
      } else if (code) {
        setApplyPromoCodeLoader(true)
      } else {
        setLoading(true);
      }

      const requestOption = {
        orderId: orderId,
        userId: userId,
        customerId: loginCustomerId,
        orderNumber: typeof orderNumber === 'string'
          ? parseInt(orderNumber.replace('INB', '').trim(), 10)
          : Number(orderNumber),
        domainNumber: domainNumber,
        ...(finalPromoCode && { code: finalPromoCode }) // Add code only if present
      };

      const response = await API.post(
        `${import.meta.env.VITE_BACKEND_API}/billinglist?orderType=AUTOMATED`,
        requestOption
      );
      console.log("response", response);

      if (!response || response.status !== 200) {
        throw new Error("Failed to fetch data. Invalid response.");
      }

      const result = response.data[0];
      setOrder(result);
      if (!result) {
        throw new Error("Received undefined data.");
      }
      setOrderNumber(result.order[0].orderNumber);
      // Combine invoiceItemList and domainDetailList
      const invoiceItems = result.order[0]?.invoiceItemList || [];
      const domainDetails = result.domainDetailList || [];
      const discountPrice = result?.discountPrice || 0; // Get discount price from the response

      console.log(domainDetails);
      console.log(invoiceItems);
      console.log(result);

      // Map and combine the invoice items with domain details
      const combinedData = [
        ...invoiceItems.map(item => ({
          ...item,
          type: "INVOICE_ITEM", // Add a flag for item type
        })),
        ...domainDetails.map(domain => ({
          productDescription: domain.domain,
          quantity: 1,
          description: domain.description,
          subTotalPrice: domain.premiumRegistrationPrice,
          unitPrice: domain.premiumRegistrationPrice,
          type: "DOMAIN_DETAIL" // Add a flag for domain type
        }))
      ];
      setDomainsState(combinedData);
      setData(response.data);
      setDiscountPrice(discountPrice);
      setThisMonthTotalAmount(result?.totalAmount);
      setNextMonthTotalAmount(result?.totalNextMonthAmount);
      setInvoiceId(result?.id);
      setInvoiceNumber(result?.invoiceNumber);
      setTaxAmount(result?.taxAmount || 0);

      if (code && result.discountPrice != 0) {
        showSnackbar("Promo code Applied Successfully", "success")
      } else if (code && result.discountPrice == 0) {
        showSnackbar("Invalid Promo Code", "error")
        setDisableInput(false);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
    } finally {
      setLoading(false);
      setApplyPromoCodeLoader(false);
    }
  };

  // Handle route to order table
  const handleRouteToOrderTable = async () => {
    try {
      setLoading(true);

      const response = await API.get(
        `${import.meta.env.VITE_BACKEND_API}/sendEmailForOrderPlaced?userId=${userId}&invoiceId=${invoiceId}`
      );
      if (response.status === 200) {
        navigate(`${import.meta.env.VITE_APP_BASE_PATH}/orders-view/`);
      }
    } catch (error) {
      console.error("Error occurred while processing payment:", error);
    } finally {
      setLoading(false);
    }
  }

  // Handle apply promo code
  const handleApplyPromoCode = () => {
    fetchData(promoCode)
  }

  useEffect(() => {
    const storedDomainNumber = localStorage.getItem("dId");

    if (storedDomainNumber) setDomainNumber(storedDomainNumber);
  }, [])

  useEffect(() => {
    localStorage.setItem("dId", domainNumber);
  }, [domainNumber]);

  useEffect(() => {
    localStorage.setItem("automationStep", currentStep);
  }, [currentStep]);

  useEffect(() => {
    if (orderId) {
      localStorage.setItem("automationOrderId", orderId);
    }
  }, [orderId]);

  useEffect(() => {
    if (orderNumber) {
      localStorage.setItem("automationOrderNo", orderNumber);
    }
  }, [orderNumber]);

  useEffect(() => {
    try {
      localStorage.setItem("domain-price-list", JSON.stringify(domainPriceList));
    } catch (e) {
      // ignore storage errors
    }
  }, [domainPriceList])

  useEffect(() => {
    sessionStorage.setItem("domainEmailAccountData", JSON.stringify(domainEmailAccountData))
  }, [domainEmailAccountData])

  // Fetch data on mount if we are on the checkout step
  useEffect(() => {
    // Only call this automatically if returning from payment gateway (orderId is present but data is empty)
    if (currentStep === 2 && orderId && orderNumber && !order) {
      fetchData("");
    }
  }, [currentStep, orderId, orderNumber, order]);

  const next = () => {
    setCurrentStep((prev) => prev + 1);
  };

  const prev = () => {
    setCurrentStep((prev) => prev - 1);
  };

  return (
    <DomainContext.Provider
      value={{
        domainNumber, setDomainNumber,
        domainPriceList, setDomainPriceList,
        domainEmailAccountData, setDomainEmailAccount,
        query, setQuery,
        suggestions, setSuggestions,
        selectedDomains, setSelectedDomains,
        cart, setCart,
        isloading, setIsLoading,
        orderId, setOrderId,
        orderNumber, setOrderNumber,
        domainList, setDomainList,
        emailAccountData, setEmailAccountData,
        isPrevious, setIsPrevious,
        currentStep, setCurrentStep,
        next, prev,
        emailFormData, setEmailFormData,
        setIsCheckoutDisable, isCheckoutDisable,
        thisMonthTotalAmount, setThisMonthTotalAmount,
        thisYearDomainTotal, setThisYearDomainTotal,
        setInvoiceNumber, invoiceNumber,
        // New checkout-related exports
        data, setData,
        loading, setLoading,
        invoiceId, setInvoiceId,
        promoCode, setPromoCode,
        nextMonthTotalAmount, setNextMonthTotalAmount,
        discountPrice, setDiscountPrice,
        taxAmount, setTaxAmount,
        applyPromoCodeLoader, setApplyPromoCodeLoader,
        fetchData,
        handleRouteToOrderTable,
        handleApplyPromoCode,
        setOrgName,
        orgName,
        order,
        setOrder,
        hasClickedCheckout,
        setHasClickedCheckout,
        isFormValid,
        setIsFormValid,
        emails,
        setEmails,
        domainsState,
        setDomainsState,
        disableInput,
        setDisableInput,
        isOrgNameSubmitted,
        setIsOrgNameSubmitted
      }}
    >
      {children}
    </DomainContext.Provider>
  );
};

// PropTypes validation for DomainProvider component
DomainProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { DomainContext, DomainProvider };
